import { Notification } from '../../model/dto/notification/notification';
import DateUtils from './date-utils';
import StringUtils from './string-utils';
import { OvTableData } from '../../../components/UI/molecules/OvTable';

export class NotificationDataUtils {
  static mapNotificationToTableDataFormat(
    notification?: Notification
  ): OvTableData {
    return [
      {
        label: 'notifications.fields.notificationContent',
        translateLabel: true,
        value: notification?.notification_content?.id,
        linkUrl: `/notification-contents/general/${notification?.notification_content?.id}`,
        linkShouldNotRedirect: true,
      },
      {
        label: 'notifications.fields.user',
        translateLabel: true,
        value: notification?.user?.email,
        linkUrl: `/users/${notification?.user_id}`,
        linkShouldNotRedirect: true,
      },
      {
        label: 'notifications.fields.isSeen',
        translateLabel: true,
        value: notification?.is_seen,
        prettifiedValue: StringUtils.getPrettifiedBooleanValue(
          notification?.is_seen
        ),
      },
      {
        label: 'notifications.fields.isVisible',
        translateLabel: true,
        value: notification?.is_visible,
        prettifiedValue: StringUtils.getPrettifiedBooleanValue(
          notification?.is_visible
        ),
      },
      {
        label: 'notifications.fields.isApprovementPending',
        translateLabel: true,
        value: notification?.is_approvement_pending,
        prettifiedValue: StringUtils.getPrettifiedBooleanValue(
          notification?.is_approvement_pending
        ),
      },
      {
        label: 'notifications.fields.isApproved',
        translateLabel: true,
        value: notification?.is_approved,
        prettifiedValue:
          notification?.is_approved === true ||
          notification?.is_approved === false
            ? StringUtils.getPrettifiedBooleanValue(notification?.is_approved)
            : '-',
      },
      {
        label: 'notifications.fields.userResponse',
        translateLabel: true,
        value: notification?.user_response_action_type,
        prettifiedValue: notification?.user_response_action_type ?? '-',
      },
      {
        label: 'notifications.fields.isInsightHelpful',
        translateLabel: true,
        value: notification?.is_insight_helpful,
        prettifiedValue:
          notification?.is_insight_helpful === true ||
          notification?.is_insight_helpful === false
            ? StringUtils.getPrettifiedBooleanValue(
                notification?.is_insight_helpful
              )
            : '-',
      },
      {
        label: 'notifications.fields.feedbackContent',
        translateLabel: true,
        value: notification?.feedback_content,
        prettifiedValue: notification?.feedback_content ?? '-',
      },
      {
        label: 'notifications.fields.seenAt',
        translateLabel: true,
        value: notification?.is_seen_at,
        prettifiedValue: notification?.is_seen_at
          ? DateUtils.formatDate(
              notification?.is_seen_at as unknown as Date,
              'MMMM DD, YYYY, HH:mm:ss'
            )
          : '-',
      },
      {
        label: 'notifications.fields.publishedAt',
        translateLabel: true,
        value: notification?.published_at,
        prettifiedValue: notification?.published_at
          ? DateUtils.formatDate(
              notification?.published_at as unknown as Date,
              'MMMM DD, YYYY, HH:mm:ss'
            )
          : '-',
      },
      {
        label: 'notifications.fields.publishAt',
        translateLabel: true,
        value: notification?.publish_at,
        prettifiedValue: notification?.publish_at
          ? DateUtils.formatDate(
              notification?.publish_at as unknown as Date,
              'MMMM DD, YYYY, HH:mm:ss'
            )
          : '-',
      },
      {
        label: 'notifications.fields.createdAt',
        translateLabel: true,
        value: notification?.created_at,
        prettifiedValue: notification?.created_at
          ? DateUtils.formatDate(
              notification?.created_at as unknown as Date,
              'MMMM DD, YYYY, HH:mm:ss'
            )
          : '-',
      },
      {
        label: 'notifications.fields.updatedAt',
        translateLabel: true,
        value: notification?.updated_at,
        prettifiedValue: notification?.updated_at
          ? DateUtils.formatDate(
              notification?.updated_at as unknown as Date,
              'MMMM DD, YYYY, HH:mm:ss'
            )
          : '-',
      },
    ];
  }
}
